import React from "react"
import { StripeProvider } from "react-stripe-elements"

import Checkout from "./checkout"

class CampBilling extends React.Component {
  render() {
    return (
      <StripeProvider apiKey="pk_test_1XW1t7vvwadhlToUFXWilbIE">
        <Checkout />
      </StripeProvider>
    )
  }
}

export default CampBilling



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampBilling/index.js